import { mountFormElement } from '../../../components/formElementBlock.component';
import { mountButton } from '../../../components/button.component';
import {
    BTX_MNP,
    CONTAINER_AUTHENTICATE_BTN,
    CONTAINER_MNP_NOTIFICATION,
    CONTAINER_PHONE_NUMBER,
    CONTAINER_RESET_BTN,
    CONTAINER_SMS_CODE,
    CONTAINER_VALIDATE_PHONE_NUMBER_BTN,
    ID_PHONE_NUMBER_INPUT,
    ID_SMS_INPUT,
} from '../constant';
import { mountNotification } from '../../../components/notification.component';
import { IFormActions } from '../action';
import {
    BtxType,
    IComponents,
} from '../interfaces/main.interface';
import {
    EXACT_LENGTH_6,
    VALIDATOR_ONLY_NUMBERS,
    VALIDATOR_PHONE_NUMBER,
    validateForm,
} from './validator.helper';

/**
 * mountUIElements
 */
export const mountUIElements = (actions: IFormActions, btx: BtxType): IComponents | null => {
    const { sendTan, setMtanStep, login } = actions;

    const loginEvent = () => {
        const phoneNumberInput = document.getElementById(ID_PHONE_NUMBER_INPUT) as HTMLInputElement;
        const smsInput = document.getElementById(ID_SMS_INPUT) as HTMLInputElement;
        login(phoneNumberInput.value.trim(), smsInput.value.trim());
    };

    const sendTanEvent = () => {
        const phoneNumberInput = document.getElementById(ID_PHONE_NUMBER_INPUT) as HTMLInputElement;
        const phoneNumber = phoneNumberInput?.value.trim();

        if (phoneNumber) {
            sendTan(phoneNumber);
        }
    };

    const mnpFlow = btx === BTX_MNP;
    const phoneInputComponent = mountFormElement(CONTAINER_PHONE_NUMBER, sendTanEvent, [VALIDATOR_PHONE_NUMBER]);
    const smsInputComponent = mountFormElement(CONTAINER_SMS_CODE, loginEvent, [VALIDATOR_ONLY_NUMBERS, EXACT_LENGTH_6]);
    const loginButtonComponent = mountButton(CONTAINER_AUTHENTICATE_BTN, loginEvent);
    const sendMtanButtonComponent = mountButton(CONTAINER_VALIDATE_PHONE_NUMBER_BTN, sendTanEvent);

    mountButton(CONTAINER_RESET_BTN, ()=> setMtanStep(0));

    if (mnpFlow) {
        mountNotification(CONTAINER_MNP_NOTIFICATION);
    }

    if (phoneInputComponent && sendMtanButtonComponent) {
        validateForm([phoneInputComponent], sendMtanButtonComponent);
    }

    if (smsInputComponent && loginButtonComponent) {
        validateForm([smsInputComponent], loginButtonComponent);
    }

    return {
        phoneInputComponent,
    };
};
